import dynamic from 'next/dynamic';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Text from '@hiredigital/ui/Text/Text';

// import BlogStory from './BlogStory';
import Styles from './BlogList.module.scss';
import InteractiveButton from '../InteractiveButton/InteractiveButton';

const BlogStory = dynamic(() => import('./BlogStory'), { ssr: false });

const BlogStoryList = ({ list, start, end, hideMore, order, isEnterprise, hideTitle = false }) => {
  if (order) {
    list.sort((a, b) => order.indexOf(a.slug) - order.indexOf(b.slug));
  }
  return (
    <>
      {!hideTitle && (
        <div className={Styles.more}>
          <div>
            <div>
              <Text
                element='h2'
                size={Text.Size.SUBHEADLINE}
                color={Text.Color.BLACK}
                style={{ marginBottom: '16px' }}>
                Latest Blog Posts
              </Text>
            </div>
            <div>
              <Text element='h4' size={Text.Size.SUBHEAD} color={Text.Color.GREY}>
                Tool and strategies modern teams need to help their companies grow.
              </Text>
            </div>
          </div>
          <div style={{ alignSelf: 'center' }}>
            {!hideMore && (
              <InteractiveButton type={InteractiveButton.Type.BLUE} title='' href='/blog'>
                {`View all posts`}
              </InteractiveButton>
            )}
          </div>
        </div>
      )}
      <div className={classNames(Styles.list, list.length > 1 ? '' : Styles.listSingle)}>
        {list.slice(start, end).map((story, index) => {
          const post = story?.node || story;
          return (
            <BlogStory
              isEnterprise={isEnterprise}
              className={classNames(Styles.item, list.length > 1 ? '' : Styles.itemSingle)}
              story={post}
              key={index}
            />
          );
        })}
      </div>
    </>
  );
};

BlogStoryList.propTypes = {
  isEnterprise: PropTypes.bool,
  list: PropTypes.array,
  start: PropTypes.number,
  end: PropTypes.number,
  hideMore: PropTypes.bool,
  order: PropTypes.array,
};

BlogStoryList.defaultProps = {
  order: null,
  start: 0,
  end: 3,
  list: [],
  hideMore: false,
  isEnterprise: false,
};

export default BlogStoryList;
